import styled from '@emotion/styled';
import { SectionTitle } from '@presentation/components';
import { responsiveFontSize } from '@presentation/styles';

export const ModalSectionTitle = styled(SectionTitle)`
  ${responsiveFontSize(32, 4)}
`;

export const TextContainer = styled.div`
  margin: 16px 0;
`;

export const IconsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 30px;
  font-size: 12px;

  svg {
    font-size: 24px;
    color: ${(props) => props.theme.color.blue.default};
  }
`;
